import React from 'react'
import PropTypes from 'prop-types'
import {withStyles} from 'material-ui/styles/index'
import {Button, LoadingIndicator} from '../../../components'
import {Container, Subtitle, Title} from '../../flow'
import Grid from '../../../common/components/Grid'
import {
  CardCVCInput,
  CardExpiryInput,
  CardholderNameInput,
  CardNumberInput,
  DocumentNumberInput,
  DocumentTypeSelector,
} from '../../../common/components/CreditCardInput'

const styles = (theme) => ({
  container: {maxWidth: 328, margin: '0 auto'},
  title: {marginBottom: 20},
  button: {margin: '30px 0 5px 0'},
})

class CardStep extends React.Component {

  static displayName = 'CardStep.component'

  state = {
    type: null,
  }

  componentDidMount() {
    this.props.updateUrl()
  }

  handleNumberChange = (value, type) => {
    this.setState({type})
    this.props.setNumber(value)
  }

  handleExpiryChange = (month, year) => {
    this.props.setExpiry(month + ' / ' + year)
  }

  handleCVVChange = cvc => {
    this.props.setCVC(cvc)
  }

  handleNameChange = name => {
    this.props.setCardholderName(name)
  }

  handleDocumentTypeChange = name => {
    this.props.setDocumentType(name)
  }

  handleDocumentNumberChange = name => {
    this.props.setDocumentNumber(name)
  }

  render() {
    const {classes} = this.props
    return (
      <Container className={classes.container}>
        <Title className={classes.title}>Indicanos el método de pago</Title>
        <Subtitle>Los costos de almacenaje dependen del tamaño del ítem almacenado.</Subtitle>
        <div style={{position: 'relative', marginTop: 20}}>
          <Grid container>
            <Grid item xs={12} style={{paddingLeft: 0, paddingRight: 0}}>
              <CardNumberInput onChange={(v, e, t) => this.handleNumberChange(v, t)} autoFocus={true}/>
            </Grid>
            <Grid item xs={6} style={{padding: 0}}>
              <CardExpiryInput onChange={(m, y) => this.handleExpiryChange(m, y)} margin="dense"/>
            </Grid>
            <Grid item xs={6} style={{padding: 0}}>
              <CardCVCInput onChange={(v) => this.handleCVVChange(v)} margin="dense" type={this.state.type}/>
            </Grid>
            <Grid item xs={12} style={{padding: 0}}>
              <CardholderNameInput onChange={(v) => this.handleNameChange(v)} margin="dense"/>
            </Grid>
            <Grid item xs={12} style={{padding: 0}}>
              <DocumentTypeSelector onChange={(v) => this.handleDocumentTypeChange(v)} margin="dense" options={
                this.props.documentTypes.map(t => ({
                  label: t.name,
                  value: t.id,
                }))
              }/>
            </Grid>
            <Grid item xs={12} style={{padding: 0}}>
              <DocumentNumberInput onChange={(v) => this.handleDocumentNumberChange(v)} margin="dense"/>
            </Grid>
          </Grid>
        </div>
        <div className={classes.button}>
          <LoadingIndicator show={this.props.isButtonLoading}>
            <Button
              variant={'primary'}
              fullWidth={true}
              onClick={() => this.props.continue(this.state.type)}
            >
              Continuar
            </Button>
          </LoadingIndicator>
        </div>
      </Container>
    )
  }

  static propTypes = {
    add: PropTypes.shape({
      number: PropTypes.string,
      expiry: PropTypes.string,
      cvc: PropTypes.string,
      cardholderName: PropTypes.string,
    }),
    save: PropTypes.func.isRequired,
    setSelected: PropTypes.func.isRequired,
    setNumber: PropTypes.func.isRequired,
    setExpiry: PropTypes.func.isRequired,
    setCVC: PropTypes.func.isRequired,
    setCardholderName: PropTypes.func.isRequired,
    documentTypes: PropTypes.array,
    documentType: PropTypes.string,
    setDocumentType: PropTypes.func.isRequired,
    documentNumber: PropTypes.string,
    setDocumentNumber: PropTypes.func.isRequired,
    isFormLoading: PropTypes.bool,
    isButtonLoading: PropTypes.bool,
    isButtonDisabled: PropTypes.bool,
    error: PropTypes.string,
    updateUrl: PropTypes.func.isRequired,
  }
}

export default withStyles(styles, {withTheme: true})(CardStep)



// WEBPACK FOOTER //
// ./src/sections/depositV2/components/card.step.jsx